import * as FavCache from '@finn-no/favorite-api-browser-client';
import * as React from 'react';
import React__default, { forwardRef, useState, useMemo, useEffect, useRef, useCallback, useImperativeHandle } from 'react';
import scrollIntoView from 'scroll-into-view-if-needed';
import classNames from 'classnames';
import { BottomSheetToolbar as BottomSheetToolbar$2, BottomSheet } from '@finn-no/troika-react-bottom-sheet';
import { FlatButton, Button, CallToActionButton } from '@finn-no/troika-react-buttons';
import { ModalContent as ModalContent$2, ModalFooter, Modal } from '@finn-no/troika-react-modal';
import Panel from '@finn-no/troika-react-panel';
import tracking from '@finn-no/analytics';
import pulse from '@finn-no/pulse-sdk';
import { PaginationContainer, PrevPage, Pages, Page, CurrentPage, NextPage } from '@finn-no/troika-react-pagination';
import { TextField, SearchButton } from '@finn-no/troika-react-textfield';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var classes = {"modal":"App-module_modal__3YxbT","numFavs":"App-module_numFavs__1deXr","troikaBlue":"App-module_troikaBlue__1O3y_","iconHeartActive":"App-module_iconHeartActive__25Ds6","iconHeartNeutral":"App-module_iconHeartNeutral__ohHay","iconHeartBlueActive":"App-module_iconHeartBlueActive__2Du0i","iconHeartBlueNeutral":"App-module_iconHeartBlueNeutral__JafxO","imageHeartActive":"App-module_imageHeartActive__n0P48","imageHeartNeutral":"App-module_imageHeartNeutral__EWkep","login":"App-module_login__VoVCz","backButton":"App-module_backButton__2CBZ3","grid":"App-module_grid__p5O4H","label":"App-module_label__2HCmI","folderIcon":"App-module_folderIcon__Bestp","folderGiftIcon":"App-module_folderGiftIcon__3snBk","folderGiftIconChecked":"App-module_folderGiftIconChecked__3lIw4","folderIconChecked":"App-module_folderIconChecked__1YdYT","plusButton":"App-module_plusButton__1NLy-","plus":"App-module_plus__uVUxO","image":"App-module_image__1Ma_7","imageUnchecked":"App-module_imageUnchecked__2fFs0","imageChecked":"App-module_imageChecked__T3sJy","imageSpinner":"App-module_imageSpinner__VCMjq","save-ad-rotation":"App-module_save-ad-rotation__33g8V","listButton":"App-module_listButton__1vOk6","modalHeader":"App-module_modalHeader__1qFrS","modalFooter":"App-module_modalFooter__1w3PQ"};

var HeartButton = /*#__PURE__*/forwardRef((props, forwardRef) => {
  var {
    onClick,
    toggled,
    variant,
    numFavs
  } = props;
  var label = toggled ? 'Lagt som favoritt' : 'Legg til favoritt';
  var className = classNames('button', {
    'button--pill icon': variant === 'heart' || variant === 'heart-blue' || variant === 'heart-on-image',
    [classes.iconHeartBlueActive]: variant === 'heart-blue' && toggled,
    [classes.iconHeartBlueNeutral]: variant === 'heart-blue' && !toggled,
    [classes.iconHeartActive]: variant === 'heart' && toggled,
    [classes.iconHeartNeutral]: variant === 'heart' && !toggled,
    [classes.imageHeartActive]: variant === 'heart-on-image' && toggled,
    [classes.imageHeartNeutral]: variant === 'heart-on-image' && !toggled,
    'button--has-icon': variant === 'button',
    'u-ph16': variant === 'button' && !toggled,
    'u-ph8': variant === 'button' && toggled
  });
  var button = /*#__PURE__*/React__default.createElement("button", {
    "aria-haspopup": "dialog",
    "aria-label": "Hjertemerke",
    "aria-pressed": toggled,
    className: className,
    onClick: onClick,
    ref: forwardRef,
    title: variant === 'heart' || variant === 'heart-blue' || variant === 'heart-on-image' ? label : undefined
  }, variant === 'button' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: classNames('icon', {
      [classes.iconHeartBlueActive]: toggled,
      [classes.iconHeartBlueNeutral]: !toggled
    })
  }), label));

  if (numFavs > 0) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: classes.numFavs
    }, button, /*#__PURE__*/React__default.createElement("div", {
      className: "u-d1 u-text-left u-pt2 u-licorice"
    }, numFavs, " har lagt til som favoritt"));
  }

  return button;
});

var usePagination = _ref => {
  var {
    pageSize,
    folders,
    searchQuery,
    specialButtons
  } = _ref;
  var [currentPage, setCurrentPage] = useState(1);
  var pagination = useMemo(() => {
    // The `+ ${specialButtons}` is because we're prepending special button(s) to the list
    var totalPages = Math.ceil((folders.length + specialButtons) / pageSize); // calculate start and end item indexes with logic to handle the "Ny liste" insertion

    var startIndex = (currentPage - 1) * pageSize - (currentPage > 1 ? specialButtons : 0);
    var endIndex = Math.min(currentPage * pageSize - 1 - specialButtons, folders.length - 1);
    return {
      totalPages,
      startIndex,
      endIndex
    };
  }, [currentPage, folders.length, pageSize, specialButtons]);
  var paginatedFolders = useMemo(() => folders.filter((_, index) => index >= pagination.startIndex && index <= pagination.endIndex), [folders, pagination.endIndex, pagination.startIndex]); // If a search query happened or the list changed length we need to reset the pagination

  useEffect(() => {
    if (searchQuery || folders.length) {
      setCurrentPage(1);
    }
  }, [searchQuery, folders.length]);
  return {
    pagination,
    paginatedFolders,
    currentPage,
    setCurrentPage
  };
};

var useSearch = _ref => {
  var {
    items
  } = _ref;
  var [searchQuery, setSearchQuery] = useState('');
  var filteredFavoriteLists = useMemo(() => {
    var query = searchQuery.toLowerCase();
    return query ? items.filter(fl => fl.name.toLowerCase().includes(query)) : items;
  }, [items, searchQuery]);
  useEffect(() => {
    if (searchQuery) {
      // Track searches
      tracking.trackEvent({
        analyticsName: 'navigation.favorite-search-by-keyword',
        eventFlags: 'success',
        stringValue: 'modal',
        eventData: {
          numberOfLists: items.length.toString()
        }
      });
    }
  }, [items.length, searchQuery]);
  return {
    searchQuery,
    setSearchQuery,
    filteredFavoriteLists
  };
};

var Pagination = props => {
  var {
    currentPage,
    totalPages = 0,
    setCurrentPage
  } = props;

  if (!totalPages || totalPages <= 1) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(PaginationContainer, {
    currentPage: currentPage,
    lastPage: totalPages,
    className: "u-pt8 u-pb2"
  }, /*#__PURE__*/React__default.createElement(PrevPage, {
    href: "#",
    onClick: event => {
      event.preventDefault();
      var pulsePayload = {
        object: {
          type: "Listing",
          layout: "List",
          pageNumber: currentPage - 1
        }
      };
      pulse.trackPageView(pulsePayload);
      tracking.trackEvent({
        analyticsName: "collect.add-favorite.pagination"
      });
      setCurrentPage(currentPage - 1);
    }
  }), /*#__PURE__*/React__default.createElement(Pages, null, page => /*#__PURE__*/React__default.createElement(Page, {
    href: "#",
    onClick: event => {
      event.preventDefault();
      var pulsePayload = {
        object: {
          type: "Listing",
          layout: "List",
          pageNumber: page
        }
      };
      pulse.trackPageView(pulsePayload);
      tracking.trackEvent({
        analyticsName: "collect.add-favorite.pagination"
      });
      setCurrentPage(page);
    }
  })), /*#__PURE__*/React__default.createElement(CurrentPage, null), /*#__PURE__*/React__default.createElement(NextPage, {
    href: "#",
    onClick: event => {
      event.preventDefault();
      var pulsePayload = {
        object: {
          type: "Listing",
          layout: "List",
          pageNumber: currentPage + 1
        }
      };
      pulse.trackPageView(pulsePayload);
      tracking.trackEvent({
        analyticsName: "collect.add-favorite.pagination"
      });
      setCurrentPage(currentPage + 1);
    }
  }));
};

var Search = _ref => {
  var {
    onSearch,
    initialFocusRef
  } = _ref;
  return /*#__PURE__*/React__default.createElement(TextField, {
    ref: initialFocusRef,
    label: "S\xF8k etter en liste",
    type: "search",
    placeholder: "Navn p\xE5 en liste",
    appendAddon: /*#__PURE__*/React__default.createElement(SearchButton, null),
    onChange: event => onSearch(event.target.value)
  });
};

var christmasGiftListName = 'Mine julegaveønsker';

function dummyToast(message, _ref) {
  var {
    type
  } = _ref;
  console.log("toast ".concat(type, ": ").concat(message));
}

function useToast() {
  var [toastModule, setToastModule] = useState({
    toast: dummyToast
  });

  function importToast() {
    return _importToast.apply(this, arguments);
  }

  function _importToast() {
    _importToast = _asyncToGenerator(function* () {
      var {
        toast
      } = yield import('@fabric-ds/elements');
      setToastModule({
        toast
      });
    });
    return _importToast.apply(this, arguments);
  }

  useEffect(() => {
    importToast();
  }, []);
  return toastModule.toast;
}

var FolderButton = /*#__PURE__*/forwardRef((props, forwardRef) => {
  var {
    adExists,
    itemType,
    itemId,
    api,
    closeCallback,
    folder,
    handleError
  } = props;
  var [spinner, setSpinner] = useState(false);
  var toast = useToast();

  function handleToggleFavorite() {
    return _handleToggleFavorite.apply(this, arguments);
  }

  function _handleToggleFavorite() {
    _handleToggleFavorite = _asyncToGenerator(function* () {
      // clear out any potential error messages, if none exists then it's a no-op
      handleError('');
      setSpinner(true);
      adExists ? yield unFavorite() : yield addFavorite();
    });
    return _handleToggleFavorite.apply(this, arguments);
  }

  function addFavorite() {
    return _addFavorite.apply(this, arguments);
  }

  function _addFavorite() {
    _addFavorite = _asyncToGenerator(function* () {
      try {
        yield api.addToFolder(itemType, itemId, folder.folderid);
        var pulsePayload = {
          type: 'Click',
          intent: 'Save',
          name: 'New favorite',
          object: {
            id: "favoritelist:".concat(folder.folderid),
            type: 'UIElement',
            elementType: 'Popup',
            name: 'Favorite List',
            items: [{
              type: 'ClassifiedAd',
              id: itemType === 'Hotel' ? "hotel:".concat(itemId) : "".concat(itemId),
              contentId: "".concat(itemId),
              name: 'n/a',
              category: 'n/a'
            }]
          },
          target: {
            id: itemType === 'Hotel' ? "classified:hotel:".concat(itemId) : "classified:".concat(itemId),
            type: 'SavedList',
            name: folder.name === 'Mine julegaveønsker' ? 'Christmas list' : 'Favorite list'
          }
        };
        pulse.trackEvent(pulsePayload);
        tracking.trackEvent({
          analyticsName: 'collect.add-favorite.done',
          eventFlags: 'success'
        }); // @ts-expect-error legacy EC tracking for statistics and recommendations (and more?)

        tracking.trackEvent({
          ecType: 'AD',
          ecCategory: 'NoOfSeenByFolderMembers',
          eventData: {
            'ad.id': itemId.toString(),
            'ad.type': itemType.toString()
          }
        });
        closeCallback();
        toast("Favoritten ble lagt til i ".concat(folder.name), {
          type: 'success'
        });
      } catch (error) {
        console.error(error);
        setSpinner(false);
        handleError('Kunne ikke legge til favoritten. Prøv på nytt senere.');
      }
    });
    return _addFavorite.apply(this, arguments);
  }

  function unFavorite() {
    return _unFavorite.apply(this, arguments);
  }

  function _unFavorite() {
    _unFavorite = _asyncToGenerator(function* () {
      try {
        yield api.removeFromFolder(itemType, itemId, folder.folderid);
        var pulsePayload = {
          type: 'Click',
          intent: 'Edit',
          name: 'New favorite',
          object: {
            id: "favoritelist:".concat(folder.folderid),
            type: 'UIElement',
            elementType: 'Button',
            name: 'Favorite List',
            items: [{
              type: 'ClassifiedAd',
              id: itemType === 'Hotel' ? "hotel:".concat(itemId) : "".concat(itemId),
              contentId: "".concat(itemId),
              name: 'n/a',
              category: 'n/a'
            }]
          },
          target: {
            id: itemType === 'Hotel' ? "classified:hotel:".concat(itemId) : "classified:".concat(itemId),
            type: 'FavoriteItem',
            name: 'Classified Ad'
          }
        };
        pulse.trackEvent(pulsePayload);
        tracking.trackEvent({
          analyticsName: 'collect.remove-favorite.done',
          eventFlags: 'success'
        });
        closeCallback();
        toast("Fjernet favoritten fra ".concat(folder.name), {
          type: 'success'
        });
      } catch (error) {
        console.error(error);
        setSpinner(false);
        handleError('Kunne ikke fjerne favoritten. Prøv på nytt senere.');
      }
    });
    return _unFavorite.apply(this, arguments);
  }

  var classList = [classes.image];

  if (adExists) {
    if (folder.name === christmasGiftListName) {
      classList.push(classes.folderGiftIconChecked);
    } else if (!folder.image) {
      classList.push(classes.folderIconChecked);
    } else {
      classList.push(classes.imageChecked);
    }
  } else {
    if (folder.name === christmasGiftListName) {
      classList.push(classes.folderGiftIcon);
    } else if (!folder.image) {
      classList.push(classes.folderIcon);
    } else {
      classList.push(classes.imageUnchecked);
    }
  }

  if (spinner) {
    classList.push(classes.imageSpinner);
  }

  var image = "url(".concat(folder.image, ")");
  return /*#__PURE__*/React__default.createElement("button", {
    className: classNames(classes.listButton),
    onClick: handleToggleFavorite,
    "aria-pressed": adExists,
    ref: forwardRef
  }, /*#__PURE__*/React__default.createElement("span", {
    className: classNames(classList),
    style: {
      ['--image-url']: image
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    className: classes.label
  }, folder.name));
});

var NewListButton = /*#__PURE__*/forwardRef((_ref, forwardRef) => {
  var {
    onClick,
    variant
  } = _ref;
  return /*#__PURE__*/React__default.createElement("button", {
    className: classes.listButton,
    onClick: onClick,
    ref: forwardRef
  }, variant === 'gift' ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: classNames(classes.plusButton, classes.folderGiftIcon)
  }), /*#__PURE__*/React__default.createElement("span", {
    className: classNames(classes.label)
  }, "Lag ny \xF8nskeliste")) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: classNames(classes.plusButton, classes.plus)
  }), /*#__PURE__*/React__default.createElement("span", {
    className: classNames(classes.label)
  }, "Lag ny liste")));
});

var useCreateList = _ref => {
  var {
    api,
    itemType,
    itemId,
    setErrorMessage,
    closeCallback
  } = _ref;
  var submittingRef = useRef(false);
  var toast = useToast();
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (folderName, extraFlags) {
      // Just ignore additional submit events while processing the current request
      if (submittingRef.current) return;
      submittingRef.current = true;

      try {
        var res = yield api.createFolder(folderName);

        if (res.status === 409) {
          var x = yield res.json();
          throw x;
        }

        if (!res.ok) {
          throw res;
        }

        var {
          folderid: folderId
        } = yield res.json();
        var pulsePayload = {
          type: 'Click',
          intent: 'Create',
          name: 'New favorite list',
          object: {
            type: 'UIElement',
            id: "favoritelist:".concat(folderId),
            elementType: 'Popup'
          },
          target: {
            id: "favoritelist:".concat(folderId),
            type: 'SavedList',
            name: folderName === 'Mine julegaveønsker' ? 'Christmas list' : 'Favorite list'
          }
        };
        pulse.trackEvent(pulsePayload);
        tracking.trackEvent({
          analyticsName: 'collect.create-favorite-list',
          eventFlags: 'success',
          stringValue: extraFlags
        });

        try {
          yield api.addToFolder(itemType, itemId, folderId);
          toast("Favoritten ble lagt til i ".concat(folderName), {
            type: 'success'
          });
          var _pulsePayload = {
            type: 'Click',
            intent: 'Save',
            name: 'New favorite',
            object: {
              id: "favoritelist:".concat(folderId),
              type: 'UIElement',
              elementType: 'Popup',
              name: 'Favorite List',
              items: [{
                type: 'ClassifiedAd',
                id: itemType === 'Hotel' ? "hotel:".concat(itemId) : "".concat(itemId),
                contentId: "".concat(itemId),
                name: 'n/a',
                category: 'n/a'
              }]
            },
            target: {
              id: itemType === 'Hotel' ? "classified:hotel:".concat(itemId) : "classified:".concat(itemId),
              type: 'SavedList',
              name: folderName === 'Mine julegaveønsker' ? 'Mine julegaveønsker' : 'Favorite list'
            }
          };
          pulse.trackEvent(_pulsePayload);
          tracking.trackEvent({
            analyticsName: 'collect.add-favorite.done',
            eventFlags: 'success'
          });
        } catch (error) {
          console.error(error);
          submittingRef.current = false;
          toast('Kunne ikke legge til favoritten. Prøv på nytt senere.', {
            type: 'error'
          });
        } finally {
          closeCallback();
        }
      } catch (error) {
        console.error(error);
        submittingRef.current = false;

        try {
          if (!error.title) {
            throw new TypeError();
          }

          setErrorMessage(error.title);
        } catch (error) {
          console.error(error);
          setErrorMessage('Usjda, kunne ikke lagre listen');
        }
      }
    });

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var ChristmasGiftContext = /*#__PURE__*/React.createContext(false);
function useChristmasGift() {
  return React.useContext(ChristmasGiftContext);
}
var {
  Provider
} = ChristmasGiftContext;

var FoldersTemplate = /*#__PURE__*/forwardRef((props, forwardRef) => {
  var {
    itemType,
    itemId,
    api,
    closeCallback,
    folders,
    foldersWithItem,
    setErrorMessage,
    toggleCreateNewFolder
  } = props;
  var createList = useCreateList({
    api,
    itemType,
    itemId,
    setErrorMessage,
    closeCallback
  });
  var christmasGiftList = useChristmasGift(); // This CSS class mitigates a known style conflict between Troika and Fabric, as described
  // here https://github.schibsted.io/finn/fabric/blob/master/README.md#the-grid-class
  // The class can be removed once this component has been migrated to Fabric.

  var fabricOverrideClassName = 't-grid';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(classes.grid, " grid ").concat(fabricOverrideClassName, " grid--cols3upto640 grid--cols4upto990 grid--cols4from990")
  }, toggleCreateNewFolder && /*#__PURE__*/React__default.createElement("div", {
    key: "new-list",
    className: "grid__unit"
  }, /*#__PURE__*/React__default.createElement(NewListButton, {
    ref: forwardRef,
    onClick: toggleCreateNewFolder,
    variant: "default"
  })), christmasGiftList && toggleCreateNewFolder && !folders.some(f => f.name === christmasGiftListName) && /*#__PURE__*/React__default.createElement("div", {
    key: "new-gift-list",
    className: "grid__unit"
  }, /*#__PURE__*/React__default.createElement(NewListButton, {
    ref: forwardRef,
    onClick: () => createList(christmasGiftListName, 'christmaslist'),
    variant: "gift"
  })), folders.map((fl, index) => /*#__PURE__*/React__default.createElement("div", {
    key: fl.folderid,
    className: "grid__unit"
  }, /*#__PURE__*/React__default.createElement(FolderButton, {
    ref: !toggleCreateNewFolder && index === 0 ? forwardRef : undefined,
    adExists: !!foldersWithItem.folderIds && foldersWithItem.folderIds.includes(fl.folderid),
    itemType: itemType,
    itemId: itemId,
    api: api,
    closeCallback: closeCallback,
    folder: fl,
    handleError: message => setErrorMessage(message),
    key: fl.folderid
  }))));
});
var BottomSheetToolbar$1 = _ref => {
  var {
    onDismiss
  } = _ref;
  return /*#__PURE__*/React__default.createElement(BottomSheetToolbar$2, {
    title: "Velg liste",
    right: /*#__PURE__*/React__default.createElement(FlatButton, {
      className: "u-pa0",
      onClick: onDismiss
    }, "Lukk")
  });
};
var BottomSheetContent$1 = props => {
  var {
    itemType,
    itemId,
    api,
    closeCallback,
    errorMessage,
    foldersWithItem,
    items,
    setErrorMessage,
    toggleCreateNewFolder,
    initialFocusRef
  } = props;
  var {
    filteredFavoriteLists,
    searchQuery,
    setSearchQuery
  } = useSearch({
    items
  });
  return /*#__PURE__*/React__default.createElement(Panel, null, /*#__PURE__*/React__default.createElement(Search, {
    onSearch: searchQuery => setSearchQuery(searchQuery),
    initialFocusRef: initialFocusRef
  }), errorMessage && /*#__PURE__*/React__default.createElement("div", {
    className: "u-cherry u-mv16",
    role: "alert"
  }, errorMessage), searchQuery && filteredFavoriteLists.length < 1 && /*#__PURE__*/React__default.createElement("p", {
    className: "u-pv32 u-ph8 u-text-center u-t4"
  }, "Fant ingen lister som svarer til s\xF8ket ditt :("), /*#__PURE__*/React__default.createElement(FoldersTemplate, {
    itemType: itemType,
    itemId: itemId,
    api: api,
    closeCallback: closeCallback,
    toggleCreateNewFolder: searchQuery ? undefined : toggleCreateNewFolder,
    foldersWithItem: foldersWithItem,
    setErrorMessage: setErrorMessage,
    folders: filteredFavoriteLists
  }));
};
var ModalContent$1 = props => {
  var {
    itemType,
    itemId,
    api,
    closeCallback,
    errorMessage,
    foldersWithItem,
    items,
    setErrorMessage,
    toggleCreateNewFolder,
    initialFocusRef
  } = props;
  var {
    filteredFavoriteLists,
    searchQuery,
    setSearchQuery
  } = useSearch({
    items
  });
  var christmasGiftList = useChristmasGift();
  var numSpecialButtons = christmasGiftList && !filteredFavoriteLists.some(f => f.name === christmasGiftListName) ? 2 : 1;
  var {
    currentPage,
    paginatedFolders,
    pagination,
    setCurrentPage
  } = usePagination({
    folders: filteredFavoriteLists,
    pageSize: 8,
    searchQuery,
    specialButtons: numSpecialButtons
  });
  var focusFirstItemRef = useRef(null);
  var [shouldFocusFirstItem, setShouldFocusFirstItem] = useState(false);
  var setCurrentPageAndFocusFirstItem = useCallback(page => {
    setCurrentPage(page);
    setShouldFocusFirstItem(true);
  }, [setCurrentPage]);
  useEffect(() => {
    if (shouldFocusFirstItem && currentPage >= 0 && focusFirstItemRef.current) {
      focusFirstItemRef.current.focus(); // Setting to false again to avoid the search input losing focus when typing

      setShouldFocusFirstItem(false);
    }
  }, [currentPage, shouldFocusFirstItem]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ModalContent$2, null, /*#__PURE__*/React__default.createElement("div", {
    className: "u-mt16 ".concat(classes.modalHeader)
  }, /*#__PURE__*/React__default.createElement("h1", {
    className: "u-mt16 u-t3"
  }, "Velg liste"), /*#__PURE__*/React__default.createElement(Search, {
    onSearch: searchQuery => setSearchQuery(searchQuery),
    initialFocusRef: initialFocusRef
  })), searchQuery && filteredFavoriteLists.length < 1 && /*#__PURE__*/React__default.createElement("p", {
    className: "u-pv32 u-ph8 u-text-center u-t4"
  }, "Fant ingen lister som svarer til s\xF8ket ditt :("), errorMessage && /*#__PURE__*/React__default.createElement("div", {
    className: "u-cherry u-mv16",
    role: "alert"
  }, errorMessage), /*#__PURE__*/React__default.createElement(FoldersTemplate, {
    ref: focusFirstItemRef,
    itemType: itemType,
    itemId: itemId,
    api: api,
    closeCallback: closeCallback,
    folders: paginatedFolders,
    foldersWithItem: foldersWithItem,
    setErrorMessage: setErrorMessage,
    toggleCreateNewFolder: currentPage !== 1 || searchQuery ? undefined : toggleCreateNewFolder
  }), /*#__PURE__*/React__default.createElement(Pagination, {
    currentPage: currentPage,
    setCurrentPage: setCurrentPageAndFocusFirstItem,
    totalPages: pagination.totalPages
  })), /*#__PURE__*/React__default.createElement(ModalFooter, {
    className: "u-pt16"
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: closeCallback
  }, "Lukk")));
};

var promoteAdIdsInSortPure = (folderIds, favs) => {
  var favsComparator = folderIds => (a, b) => {
    if (a.default) {
      return -1;
    } else if (b.default) {
      return 1;
    } else if (folderIds.includes(a.folderid) && folderIds.includes(b.folderid)) {
      return 0;
    } else if (folderIds.includes(a.folderid)) {
      return -1;
    } else if (folderIds.includes(b.folderid)) {
      return 1;
    } else {
      return 0;
    }
  };

  if (folderIds) {
    var cmp = favsComparator(folderIds);
    return favs.sort(cmp);
  } else {
    return favs;
  }
};

var useFetchFolders = _ref => {
  var {
    api,
    itemType,
    itemId,
    userId
  } = _ref;
  var [items, setItems] = useState([]);
  var [foldersWithItem, setFoldersWithItem] = useState({
    itemType: itemType,
    itemId: itemId,
    folderIds: []
  });
  var [errorMessage, setErrorMessage] = useState('');
  useEffect(() => {
    var didCancel = false;

    function fetchFolders() {
      return _fetchFolders.apply(this, arguments);
    }

    function _fetchFolders() {
      _fetchFolders = _asyncToGenerator(function* () {
        try {
          var [_foldersWithItem, folders] = yield Promise.all([api.fetchFoldersForItem(itemType, itemId), api.fetchFolders().then(res => res.json())]);

          if (!didCancel) {
            setFoldersWithItem(_foldersWithItem);
            var sortedList = promoteAdIdsInSortPure(_foldersWithItem.folderIds, folders);
            setItems(sortedList);
          }
        } catch (error) {
          console.error(error);
          setErrorMessage(error.toString());
        }
      });
      return _fetchFolders.apply(this, arguments);
    }

    if (userId) {
      fetchFolders();
      return () => {
        didCancel = true;
      };
    }
  }, [itemType, itemId, api, userId]);
  return {
    items,
    errorMessage,
    foldersWithItem
  };
};

var useStartEventTracking = _ref => {
  var {
    toggled,
    userId,
    itemType,
    itemId
  } = _ref;
  useEffect(() => {
    if (userId) {
      var pulsePayload = {
        type: 'Click',
        intent: toggled ? 'Edit' : 'Create',
        name: 'New favorite',
        object: {
          id: itemType === 'Hotel' ? "classified:hotel:".concat(itemId) : "classified:".concat(itemId),
          type: 'UIElement',
          elementType: 'Button',
          items: [{
            type: 'ClassifiedAd',
            id: itemType === 'Hotel' ? "hotel:".concat(itemId) : "".concat(itemId),
            contentId: "".concat(itemId),
            name: 'n/a',
            category: 'n/a'
          }]
        },
        target: {
          id: itemType === 'Hotel' ? "classified:hotel:".concat(itemId) : "classified:".concat(itemId),
          type: 'FavoriteItem',
          name: 'Classified Ad'
        }
      };
      pulse.trackEvent(pulsePayload);
      tracking.trackEvent({
        analyticsName: 'collect.add-favorite.start',
        stringValue: toggled ? 'filled' : 'empty'
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
};

var LoginTemplate = _ref => {
  var {
    closeCallback,
    redirectUrl = window.location.href
  } = _ref;
  var setFocusRef = useCallback(element => {
    if (element !== null) {
      element.focus();
    }
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.login
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "u-t4"
  }, "Logg inn"), /*#__PURE__*/React__default.createElement("p", null, "Logg inn for \xE5 legge annonsen i dine favorittlister. Da kan du lett  finne de igjen senere, uansett hvor du er."), /*#__PURE__*/React__default.createElement("div", {
    className: "u-text-right u-mt16"
  }, /*#__PURE__*/React__default.createElement(FlatButton, {
    className: "u-mr8",
    onClick: closeCallback
  }, "Ikke n\xE5"), /*#__PURE__*/React__default.createElement("a", {
    ref: setFocusRef,
    className: "button button--cta",
    href: "/loginForm.html?redirectTo=".concat(encodeURIComponent(redirectUrl)),
    onClick: () => tracking.trackEventLater({
      analyticsName: 'user-admin.log-in.favourite-login',
      stringValue: 'modal-favorite-link'
    })
  }, "Logg inn")));
};

var BackButton = _ref => {
  var {
    onClick,
    className = 'u-pl0'
  } = _ref;
  return /*#__PURE__*/React__default.createElement(FlatButton, {
    className: classNames('button--has-icon', classes.backButton, className),
    onClick: onClick
  }, "Tilbake");
};

var NewFolderTemplate = /*#__PURE__*/forwardRef((props, ref) => {
  var {
    itemType,
    itemId,
    api,
    closeCallback,
    initialFocusRef
  } = props;
  var [folderName, setFolderName] = useState('');
  var [errorMessage, setErrorMessage] = useState('');
  useEffect(() => {
    tracking.trackEvent({
      analyticsName: 'collect.create-favorite-list',
      eventFlags: 'start'
    });
  }, []);
  var createList = useCreateList({
    api,
    itemType,
    itemId,
    setErrorMessage,
    closeCallback
  });

  function onSubmitFolder() {
    return _onSubmitFolder.apply(this, arguments);
  }

  function _onSubmitFolder() {
    _onSubmitFolder = _asyncToGenerator(function* () {
      if (!folderName.trim()) {
        if (initialFocusRef.current) {
          initialFocusRef.current.focus();
        }

        setShouldValidate(true);
        return;
      }

      return createList(folderName);
    });
    return _onSubmitFolder.apply(this, arguments);
  }

  useImperativeHandle(ref, () => ({
    submit: () => onSubmitFolder()
  })); // Validation feedback shouldn't be shown until after the user have interacted with the input

  var [shouldValidate, setShouldValidate] = useState(false);
  var inputField = /*#__PURE__*/React__default.createElement(TextField, {
    error: shouldValidate && folderName.trim().length < 1,
    helpText: "".concat(folderName.length, "/40 tegn"),
    label: "Gi listen et navn",
    maxLength: 40,
    onChange: event => setFolderName(event.target.value),
    ref: initialFocusRef,
    required: true,
    value: folderName
  });
  return /*#__PURE__*/React__default.createElement("form", {
    className: "u-pb8",
    onSubmit: event => {
      event.preventDefault();
      onSubmitFolder();
    }
  }, inputField, errorMessage && /*#__PURE__*/React__default.createElement("p", {
    className: "u-cherry",
    role: "alert"
  }, errorMessage));
});
var BottomSheetToolbar = props => {
  var {
    onCancel,
    onSubmit
  } = props;
  return /*#__PURE__*/React__default.createElement(BottomSheetToolbar$2, {
    left: /*#__PURE__*/React__default.createElement(BackButton, {
      className: "u-pa0",
      onClick: onCancel
    }),
    title: "Ny liste",
    right: /*#__PURE__*/React__default.createElement(FlatButton, {
      className: "u-pa0",
      onClick: onSubmit
    }, "Legg i liste")
  });
};
var BottomSheetContent = /*#__PURE__*/forwardRef((props, ref) => {
  var {
    itemType,
    itemId,
    api,
    initialFocusRef,
    closeCallback
  } = props;
  return /*#__PURE__*/React__default.createElement(Panel, null, /*#__PURE__*/React__default.createElement(NewFolderTemplate, {
    itemType: itemType,
    itemId: itemId,
    api: api,
    initialFocusRef: initialFocusRef,
    closeCallback: closeCallback,
    ref: ref
  }));
});
var ModalContent = /*#__PURE__*/forwardRef((props, ref) => {
  var {
    itemType,
    itemId,
    api,
    initialFocusRef,
    closeCallback,
    onCancel,
    onSubmit
  } = props;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ModalContent$2, null, /*#__PURE__*/React__default.createElement("h1", {
    className: "u-mv16 u-t3"
  }, "Ny liste"), /*#__PURE__*/React__default.createElement(NewFolderTemplate, {
    itemType: itemType,
    itemId: itemId,
    api: api,
    initialFocusRef: initialFocusRef,
    closeCallback: closeCallback,
    ref: ref
  })), /*#__PURE__*/React__default.createElement(ModalFooter, {
    className: classes.modalFooter
  }, /*#__PURE__*/React__default.createElement(BackButton, {
    onClick: onCancel
  }), /*#__PURE__*/React__default.createElement(CallToActionButton, {
    onClick: onSubmit
  }, "Legg i liste")));
});

var SaveAdBottomSheet = props => {
  var {
    itemType,
    itemId,
    api,
    isOpen,
    setOpen,
    redirectUrl,
    restoreFocus,
    toggled,
    userId
  } = props;
  useStartEventTracking({
    toggled,
    userId,
    itemType,
    itemId
  });
  var [createNewFolder, setCreateNewFolder] = useState(false);
  var toggleCreateNewFolder = useCallback(() => setCreateNewFolder(createNewFolder => !createNewFolder), []);
  var [errorMessage, setErrorMessage] = useState('');
  var {
    items,
    errorMessage: fetchFoldersErrorMessage,
    foldersWithItem
  } = useFetchFolders({
    api,
    itemType,
    itemId,
    userId
  });
  var newFolderFormRef = useRef(null);
  var FavoritesMoreOptionsFocusRef = useRef(null);
  var NewFolderTemplateFocusRef = useRef(null);
  var finalErrorMessage = errorMessage || fetchFoldersErrorMessage;
  var sharedProps = {
    open: isOpen,
    onSpringEnd: event => event.type === 'CLOSE' && setOpen(false),
    onDismiss: () => setOpen(false)
  };
  useEffect(() => {
    if (!isOpen) {
      restoreFocus();
    }
  }, [isOpen, restoreFocus]);

  if (userId) {
    if (createNewFolder) {
      return /*#__PURE__*/React__default.createElement(BottomSheet, _extends({}, sharedProps, {
        initialFocusRef: NewFolderTemplateFocusRef,
        header: /*#__PURE__*/React__default.createElement(BottomSheetToolbar, {
          onCancel: toggleCreateNewFolder,
          onSubmit: () => newFolderFormRef.current.submit()
        })
      }), /*#__PURE__*/React__default.createElement(BottomSheetContent, {
        itemType: itemType,
        itemId: itemId,
        api: api,
        closeCallback: () => setOpen(false),
        initialFocusRef: NewFolderTemplateFocusRef,
        ref: newFolderFormRef
      }));
    }

    return /*#__PURE__*/React__default.createElement(BottomSheet, _extends({}, sharedProps, {
      snapPoints: _ref => {
        var {
          maxHeight
        } = _ref;
        return [maxHeight, Math.max(maxHeight * 0.7, 510)];
      },
      header: /*#__PURE__*/React__default.createElement(BottomSheetToolbar$1, {
        onDismiss: () => setOpen(false)
      })
    }), /*#__PURE__*/React__default.createElement(BottomSheetContent$1, {
      initialFocusRef: FavoritesMoreOptionsFocusRef,
      itemType: itemType,
      itemId: itemId,
      api: api,
      closeCallback: () => setOpen(false),
      errorMessage: finalErrorMessage,
      foldersWithItem: foldersWithItem,
      items: items,
      setErrorMessage: setErrorMessage,
      toggleCreateNewFolder: toggleCreateNewFolder
    }));
  }

  return /*#__PURE__*/React__default.createElement(BottomSheet, sharedProps, /*#__PURE__*/React__default.createElement(LoginTemplate, {
    closeCallback: () => setOpen(false),
    redirectUrl: redirectUrl
  }));
};

var SaveAdModal = props => {
  var {
    itemType,
    itemId,
    api,
    setOpen,
    redirectUrl,
    restoreFocus,
    toggled,
    userId
  } = props;
  useStartEventTracking({
    toggled,
    userId,
    itemType,
    itemId
  });
  var [createNewFolder, setCreateNewFolder] = useState(false);
  var toggleCreateNewFolder = useCallback(() => setCreateNewFolder(createNewFolder => !createNewFolder), []);
  var [errorMessage, setErrorMessage] = useState('');
  var {
    items,
    errorMessage: fetchFoldersErrorMessage,
    foldersWithItem
  } = useFetchFolders({
    api,
    itemType,
    itemId,
    userId
  });
  var newFolderFormRef = useRef(null);
  var FavoritesMoreOptionsFocusRef = useRef(null);
  var NewFolderTemplateFocusRef = useRef(null);
  var closeCallback = useCallback(() => {
    setOpen(false);
    restoreFocus();
  }, [setOpen, restoreFocus]);
  var finalErrorMessage = errorMessage || fetchFoldersErrorMessage;
  var sharedProps = {
    className: classes.modal,
    isOpen: true,
    onDismiss: () => closeCallback()
  };

  if (userId) {
    if (createNewFolder) {
      return /*#__PURE__*/React__default.createElement(Modal, _extends({}, sharedProps, {
        key: "create-new-folder",
        max640: true,
        initialFocusRef: NewFolderTemplateFocusRef
      }), /*#__PURE__*/React__default.createElement(ModalContent, {
        itemType: itemType,
        itemId: itemId,
        api: api,
        initialFocusRef: NewFolderTemplateFocusRef,
        closeCallback: closeCallback,
        ref: newFolderFormRef,
        onCancel: toggleCreateNewFolder,
        onSubmit: () => newFolderFormRef.current.submit()
      }));
    }

    return /*#__PURE__*/React__default.createElement(Modal, _extends({}, sharedProps, {
      key: "select-folder",
      max640: true,
      initialFocusRef: FavoritesMoreOptionsFocusRef
    }), /*#__PURE__*/React__default.createElement(ModalContent$1, {
      itemType: itemType,
      itemId: itemId,
      api: api,
      initialFocusRef: FavoritesMoreOptionsFocusRef,
      closeCallback: closeCallback,
      errorMessage: finalErrorMessage,
      foldersWithItem: foldersWithItem,
      items: items,
      setErrorMessage: setErrorMessage,
      toggleCreateNewFolder: toggleCreateNewFolder
    }));
  }

  return /*#__PURE__*/React__default.createElement(Modal, _extends({}, sharedProps, {
    key: "login"
  }), /*#__PURE__*/React__default.createElement(LoginTemplate, {
    closeCallback: closeCallback,
    redirectUrl: redirectUrl
  }));
};

var _excluded = ["redirectUrl"];
var instance;

function getApiInstance(p) {
  if (!instance) {
    instance = new FavCache.FavoriteBrowserCache(p.userId, undefined, undefined, undefined, p.fetch, p.baseUri);
  }

  return instance;
}

function createComponent(_ref) {
  var {
    redirectUrl: _redirectUrl
  } = _ref,
      options = _objectWithoutProperties(_ref, _excluded);

  var api = getApiInstance(options);
  var {
    userId
  } = options;

  var SaveAd = props => {
    var _props$christmasGiftL, _props$toggled, _props$isOpen;

    var {
      itemType,
      itemId,
      isMobile,
      redirectUrl = _redirectUrl,
      renderNumFavs,
      variant,
      christmasGiftList = (_props$christmasGiftL = props.christmasGiftList) !== null && _props$christmasGiftL !== void 0 ? _props$christmasGiftL : false
    } = props;
    var [toggled, setToggled] = useState((_props$toggled = props.toggled) !== null && _props$toggled !== void 0 ? _props$toggled : false);
    var [isOpen, setOpen] = useState((_props$isOpen = props.isOpen) !== null && _props$isOpen !== void 0 ? _props$isOpen : false);
    var [numFavs, setNumFavs] = useState(0);
    var restoreFocusRef = useRef(null); // Handle the case of an invalid itemId

    if (process.env.NODE_ENV !== 'production') {
      if (!itemId) {
        console.error('Invalid itemId:', itemId);
        throw new Error("Invalid itemId: ".concat(itemId));
      }
    }

    useEffect(() => {
      if (userId) {
        var cleanup = api.getFavoriteState(itemType, itemId, toggled => setToggled(toggled));

        if (cleanup) {
          return () => cleanup();
        }
      }
    }, [itemType, itemId]);
    useEffect(() => {
      if (renderNumFavs) {
        var cleanup = api.subscribeToRecount(itemType, itemId, setNumFavs);

        if (cleanup) {
          return () => cleanup();
        }
      }
    }, [itemType, itemId, renderNumFavs]); // Focus is only restored by the Modal/BottomSheet if an element already had focus before opening
    // On Safari in particular buttons won't receive focus when clicking on them.

    var restoreFocus = useCallback(() => {
      setTimeout(() => {
        if (restoreFocusRef.current && document.activeElement !== restoreFocusRef.current) {
          // The scrolling behavior when calling .focus() is very unreliable and incosistent between browsers
          // The call below will ensure a consistent and satisfactory UX by scrolling things into view ahead of calling .focus()
          scrollIntoView(restoreFocusRef.current, {
            block: 'center',
            inline: 'center',
            scrollMode: 'if-needed'
          });
          restoreFocusRef.current.focus();
        }
      }, 0);
    }, []);
    var sharedProps = {
      itemType,
      itemId,
      api,
      isOpen,
      setOpen,
      redirectUrl,
      restoreFocus,
      toggled,
      userId
    };
    return /*#__PURE__*/React__default.createElement(Provider, {
      value: christmasGiftList
    }, /*#__PURE__*/React__default.createElement(HeartButton, {
      numFavs: numFavs,
      onClick: () => setOpen(true),
      ref: restoreFocusRef,
      toggled: toggled,
      variant: variant
    }), isOpen && (isMobile ? /*#__PURE__*/React__default.createElement(SaveAdBottomSheet, sharedProps) : /*#__PURE__*/React__default.createElement(SaveAdModal, sharedProps)));
  };

  return SaveAd;
}

export { createComponent as default };
//# sourceMappingURL=index.esm.js.map
